import React, { useState, useEffect } from 'react';
import { ContentBox } from '../ContentBox';


export function EmployeeResumeJobInfo({ detail }) {
    const [mDetail, setDetail]=useState({})
    useEffect(()=>{
        if(detail !== undefined && detail !== mDetail){
            setDetail(detail)
            //console.log(detail)
        }
    },[detail])
    var title = "基本資訊"
    var content =
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className="col-md-2">
                        <p>姓名</p>
                        <p className="text-success">{mDetail.name}</p>
                    </div>
                    <div className="col-md-2">
                        <p>報到日期</p>
                        <p className="text-success">{mDetail.enrollDate}</p>
                    </div>
                    <div className="col-md-2">
                        <p>員工編號</p>
                        <p className="text-success">{mDetail.employeeId}</p>
                    </div>
                    <div className="col-md-2">
                        <p>所屬公司</p>
                        <p className="text-success">{mDetail.companyName}</p>
                    </div>
                    <div className="col-md-2">
                        <p>部門</p>
                        <p className="text-success">{mDetail.departmentName}</p>
                    </div>
                    <div className="col-md-2">
                        <p>職務</p>
                        <p className="text-success">{mDetail.roleName}</p>
                    </div>

                </div>
            </div>
            <div className="hr-line-dashed"></div>




            <div className="row text-right ">
                <div className="col-sm-12">


                </div>
            </div>
        </>
    return(
        <ContentBox title={title} content={content} hasDrawer={true} />
    )
}